<template>
  <div class="continueButton">
    <button
      class="button"
      :disabled="disabled"
      @click="go(to)"
      ref="continueButton"
    >{{ text || 'Continue' }}</button>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: [
    "to",
    "hasBackButton",
    "disabled",
    "answered",
    "text",
    "before",
    "after"
  ],
  computed: {
    ...mapState(["errors"])
  },
  methods: {
    ...mapActions([
      "nextSection",
      "prevSection",
      "visibleFieldsValidated",
      "checkBusinessHours",
      "save"
    ]),

    /**
     * [goBack description]
     * @return {[type]} [description]
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * [go description]
     * @param  {[type]} to [description]
     * @return {[type]}    [description]
     */
    go(to) {
      let that = this;

      if (this.before) {
        this.before();
      }

      this.checkBusinessHours();

      this.visibleFieldsValidated().then(() => {
        let errorsLength = Object.keys(this.errors).length;
        if (errorsLength < 1) {
          this.$router.push(to);
          $("body, html").scrollTop(0);
        }
      });

      this.save().then(res => {
        let lead = res.data;
        // Set the UUID
        // window.trueUUID = lead.uuid;
        // If a function is passed for after the save
        if (that.after) {
          that.after();
        }
      });
    },

    /**
     * [clickOnEnter description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    clickOnEnter(e) {
      if (e.keyCode === 13) {
        let continueButton = this.$refs.continueButton;
        continueButton.click();
      }
    }
  },

  mounted() {
    window.continueButtonEnterEvent = window.addEventListener(
      "keypress",
      this.clickOnEnter,
      false
    );
  },

  destroyed() {
    window.removeEventListener("keypress", this.clickOnEnter, false);
  }
};
</script>

<style lang="css">
</style>
